import { render } from "./FileStatusCenter.vue?vue&type=template&id=02b2aaf8&scoped=true"
import script from "./FileStatusCenter.vue?vue&type=script&lang=js"
export * from "./FileStatusCenter.vue?vue&type=script&lang=js"

import "./FileStatusCenter.vue?vue&type=style&index=0&id=02b2aaf8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b2aaf8"]])

export default __exports__